// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-31UcbacZ clearfix","list":"list-5nIThIBi","black_01":"black_01-OuHYOzpv","word_01":"word_01-3l1RMW6E"};